<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { format, isToday, isTomorrow } from 'date-fns';
  import { time_update_minute as current_time, time as current_time_highres} from '../time';
  import { format_timespan, format_duration_b, format_daymonth, format_time_of_day, format_duration, format_elapsed } from '../time';
  import { getContext, onMount, onDestroy } from 'svelte';
  import type { MyFitnessStores } from '../MyFitness/stores';
  import CommentsButton from '@/Comments/CommentsButton.svelte';
  import DifficultyDiamonds from "../DifficultyDiamonds.svelte";
  import SessionScheduleButton from '../SessionScheduleButton.svelte';
  import ExerciseCardButtons from './ExerciseCardButtons.svelte';
  import ExerciseImageCarousel from './ExerciseImageCarousel.svelte';
  import ActivityBreakthrough from './ActivityBreakthrough.svelte';
  import SessionVideoData from './SessionVideoData.svelte';
  import SessionButtons from './SessionButtons.svelte';
  import { type XSSDetails, kmToMile, meterToFoot, specificityToRating, xssDeviationToCategory, formatXSSDetails, maybeFade } from "../Util/utils";
  import type { Writable } from 'svelte/store';
  import type { CalendarEventBody } from '../Util/api';
  import Avatar from '../Avatar.svelte';
  import XssDeviationIcon from '../MyFitness/XssDeviationIcon.svelte'
  import { ActivityTag } from '@/Common/ActivityTag';
  import { TagWrapper } from '@/Common';
  import GroupMemberAvatars from '@/Common/GroupMemberAvatars.svelte';
  import type { GroupMember } from '@/Common/ActivityFunctions';

  export let selected_path: string;
  export let selectable: boolean = false;
  $: selected = path == selected_path;

  // Flags
  export let isActivityPicker = false;
  export let isCalendarCard = false;
  export let exerciseType: string;
  export let isReady: boolean = false;
  export let isNext: boolean = false;
  export let showPlayButton: boolean = true;
  export let showScheduleButton: boolean = true;
  export let showClearButton: boolean = false;
  export let showOwner: boolean = false;
  export let showExerciseCardButtons: boolean = true;
  export let showTags: boolean = true;
  export let showBorder: boolean = true;
  let isSession: boolean
  let isActivity: boolean
  let isWorkout: boolean

  // exerciseType has to be Activity for ActivitiesDash otherwise it breaks. This is a workaround for the tag.
  $: exerciseTypeTag = (exerciseType=="Activity" && session_instance_id) ? "Session" : (exerciseType=="Activity" && workout_id) ? "Workout" : exerciseType
  
  //@ts-ignore
  const Xert = window.Xert

  let useFreedomUnits: boolean = Xert._displayUnits == "imperial";

  $: {
    isSession = exerciseType == "Session"
    isActivity = exerciseType == "Activity"
    isWorkout = exerciseType == "Workout"
  }

  // Common Variables
  export let name: string;
  export let images: string[] = [];
  export let trial = false;
  export let tags: any[] = [];
  export let flag : any;
  export let favorite : any;
  export let liked : any;
  export let disliked : any;
  export let distance: number;
  export let xep: number;
  export let description: string;
  export let xss: number = null;
  export let xlss: number = null;
  export let xpss: number = null;
  export let xhss: number = null;
  export let duration: number = null;
  export let difficulty: number = null;
  export let suitability: string = null;
  export let isTrainingPicker: boolean = false;
  export let isPlanned: boolean = false
  export let isRecorded: boolean = false
  export let state: string[]

  // Workout variables
  export let workout_id = null;
  export let openPlayerOnPlay: boolean = true;
  let showScheduleModal;

  // Acitivity Card variables
  export let medal: number = 0;
  export let signature: any;
  export let br_signature_changes: any;
  export let scheduled: boolean;
  export let activity_mode: string;

  export let icon;
  export let type;
  export let power_source;
  export let path;
  // Optional override for the activity link (e.g. squad-scoped /squads/{squad}/activity/{path}
  // supplied by the squad dashboard). Falls back to the owner-scoped /activities/{path}.
  export let activity_url = null;
  export let activityPath;
  export let avgPower;
  export let maxPower;
  export let avgHeartRate;
  export let maxHeartRate;
  export let avgSpeed;
  export let maxSpeed;
  export let tgf;
  export let tgc;
  export let total_intervals;

  // Sessions card variables, some also used for Activities.
  export let is_group_session: boolean = false;
  export let session_id: string = null;
  export let session_instance_id: string = null;
  export let template_id: string = null;
  export let club: any = null;
  export let workout: any;
  export let members: any[] = null;
  export let start_date: string | Date | null = null;
  export let end_date: string = null;
  export let owner: any;
  export let coach: any;
  export let sharing_type: string = null;
  export let repeat_type: string = null;
  export let group_id: string = null;
  export let joined: boolean = isUserInSession();

  export let video_id: string = null;
  export let video_name: string = null;
  export let video_provider: string = null;
  export let zoom_url: string = null;
  export let spotify_url: string = null;

  export let elevation: number;
  export let group_members: GroupMember[] = [];

  export let street_view: any;
  export let chart_url: any;
  export let map_url: any;

  export let specificity: number = null;
  export let sp: number = null;
  export let focus: any = null;
  export let sfd: number = null;
  export let targetXSS: XSSDetails | null = null

  export let user: any;

  // Sessions card lambda functions
  export let copySession: ()=>Promise<any>;
  export let allowed_to_edit = false;
  export let allowed_to_schedule = true;

  export let deleteActivityCard: (string)=>any = ()=>{};
  export let reloadExercises: ()=>any = ()=>{};
  export let clearExercise: ()=>any = ()=>{};

  export let joinSession: (string, bool?)=>Promise<any>;
  export let playSessionNow: (string, bool?)=>void;
  export let onScheduleCallback: (body: CalendarEventBody) => Promise<any>
  export let selectExercise: () => any;

  // Calendar exercise card variables

  export let exercise: any;
  export let enableFade: boolean = false;
  export let selectedDate:Date = null;

  export let device_info = null;
  export let data_source = null;

  function getExerciseDefaultImage(e) {
    if (e.has_map_image) {
      return e.map_url;
    } else if (e.has_chart_image) {
      return e.chart_url;
    } else {
      return e.street_view_url;
    }
  }

  function scheduleThisSession(){
    window.open(Xert.Sessions.urls.new_instance.replace("PATH", template_id));
  }

  function isUserInSession(): boolean {
    if (members == null || members.length == 0) return false;
    return members.map(v=>v.username).indexOf(Xert._username)!=-1
  }

  let copy_in_progress = false;
  function copyThisSession(){
    if(copy_in_progress) return;
    copy_in_progress = true;
    copySession().finally(()=>copy_in_progress = false);
  }

  // Sessions card local variables
  let start_date_obj = null;
  let end_date_obj = null;
  let starting_at_date = null;
  let in_past = false;
  let not_yet_ended = true;
  let starting_soon = false;
  let in_progress = false;
  let allowed_to_delete = false;

  let members_to_show = [];
  let hidden_members = [];

  // Card garmin functions
  let canSendToGarmin = false;
  let canSendToZwift = false;
  let canSendToWahoo = false;

  // Sessions card functions
  let user_params: Writable<any> = getContext('user_params');
  const myFitness: MyFitnessStores | undefined = getContext('myFitness');
  const commentCounts = myFitness?.commentCounts;
  $: is_premium = ($user_params) ? ($user_params.premium ?? false) : true;
  $: allowed_to_delete = ((!isTrainingPicker || isNext || in_progress) && (owner?.username == Xert._username)) ;

  let isTemplate = template_id && !session_id;
  $: start_date_obj = start_date ? new Date(start_date) : null;

  $: if(!isTemplate && isSession) {
    end_date_obj = new Date(end_date);

    starting_at_date = format_daymonth(start_date_obj, $current_time);

    in_past = start_date_obj < $current_time;
    not_yet_ended = $current_time_highres < end_date_obj;
    starting_soon = !in_past && $current_time.getTime()+1800*1000 > start_date_obj.getTime();
    in_progress = in_past && not_yet_ended;

    
    members_to_show = members ? [...members] : [];
    members_to_show.sort((a, b) => b.is_workout_in_progress - a.is_workout_in_progress);
    hidden_members = members_to_show.splice(5);
  }

  $: if (total_intervals && total_intervals <= 50) {
    canSendToGarmin = Xert._hasTrainingGarmin;
  } else {
    canSendToGarmin = false;
  }
  canSendToZwift = Xert._hasTrainingZwift;
  canSendToWahoo = Xert._hasTrainingWahoo;

  // Helper functions
  function tidy(number) {
    return Math.round(10 * Math.abs(number)) / 10;
  }

  function formatTime(unixTime) {
    let timeString = "";
    
    if(Math.floor(unixTime / 3600) != 0) {
      timeString += (unixTime / 3600 < 10) ? "0" + Math.floor(unixTime / 3600) : Math.floor(unixTime / 3600);
      timeString += ":";
    }

    unixTime %= 3600;
    timeString += (unixTime / 60 < 10) ? "0" + Math.floor(unixTime / 60) : Math.floor(unixTime / 60);

    timeString += ":";

    unixTime %= 60;
    timeString += (unixTime < 10) ? "0" + Math.floor(unixTime) : Math.floor(unixTime);

    return timeString;
  }

  let titleLink: string;
  $: { if(isActivity) titleLink = activity_url ?? ("/activities/" + path);
  else if(isWorkout) titleLink = "/workout/" + path + "/view";
  else if(isSession) titleLink = isTemplate ? ("/session-templates/" + template_id + "/details") : ("/sessions/" + session_id + "/details");
  }
  let workoutLink: string;
  // TODO: use route() function for this and titleLink.
  $: workoutLink = workout ? "/workout/"+workout.path+"/view" : null;
  const updateTags = (icon: string, exerciseTypeTag: string, power_source: string, repeat_type: string, sharing_type: string, tags: string[]) => {
    const activityTag = ActivityTag("default")
    return [
      activityTag.exerciseType({exerciseType: exerciseTypeTag}),
      activityTag.type(exercise),
      activityTag.powerSource({power_source}),
      activityTag.repeat({repeat_type}),
      activityTag.sharing({sharing_type}),
      isActivity ? activityTag.device({data_source, device_info}) : null,
      isActivity ? activityTag.manual({activity_mode}) : null,
      isActivity ? activityTag.merged({state}) : null,
      isActivity ? activityTag.group({group_members}) : null,
      ...activityTag.list(tags)
    ].filter(tag => tag)
  }

  // Binding variables for CSS
  let cardSize: ResizeObserverSize[] | null = null;

  let halfView: boolean = false;
  let phoneView: boolean = false;
  let shrinkAnchored: boolean = false;
  let anchoredWidth: number = 320;
  $: if (cardSize && cardSize.length > 0) {
    const size = cardSize[0].inlineSize;
    // Reduced Width View and mobile View
    halfView = (size < 1275);
    phoneView = (size < 530);
    // Shrink carousel and card data
    shrinkAnchored = (!halfView && size < 1465) || (!phoneView && size < 660) || (size < 380);
    anchoredWidth = shrinkAnchored ? 230 : 320;
  }

  $: timestamp = !isNaN(start_date_obj) ? format_time_of_day(start_date_obj, $current_time) + " - " + format_duration_b(duration) : null;

  let xssDetails: XSSDetails | null = null
  let formattedXSSstrings: XSSDetails<string> | null = null
  $: if (xss) {
    xssDetails = {xss, xlss, xhss, xpss}
    formattedXSSstrings = formatXSSDetails(xssDetails)
  } else {
    xssDetails = null
    formattedXSSstrings = null
  }
  
  function selectAndSave(){
    if(!isCalendarCard) return;
    let dateStr = isToday(selectedDate)?"Today":isTomorrow(selectedDate)?"Tomorrow": format(selectedDate, "EEEE, MMMM do");
    Xert.global(`${name} has been selected for ${dateStr}`)
    selectExercise();
  }

</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<my-box on:exercisechange={reloadExercises} on:selectAndSave={selectAndSave} bind:borderBoxSize={cardSize} class:selectable class:selected on:click class:showBorder in:maybeFade={{duration: 1000, enableFade}}>
  {#if isActivity && path && commentCounts && (showOwner ? user?.messaging_enabled : Xert._hasMessagingFeature)}
    <div class="comments-button-anchor">
      <CommentsButton
        activityPath={path}
        activityName={name}
        total={$commentCounts[path]?.total}
        unread={$commentCounts[path]?.unread}
      />
    </div>
  {/if}
  <div style={!halfView && "display: none;"}>
  <h3 class="title">
    <a href={titleLink} target={isWorkout ? "workout" : "activity"}>
      {name != null && name.length > 0 ? name : "ERROR: No Name"}
    </a>
  </h3>
  {#if showOwner}
  <div class="ellipsis" style="margin: 20px;">
    <Avatar shape="circle" {...user} pad_right="true"/>
    <h4 class="title w400 ellipsis" style="display: inline; vertical-align: middle;">
      {user != null  ? `${user.first_name} ${user.last_name}`: "ERROR: No username"}
    </h4>
  </div>
  {/if}
  </div>
  <div class="primary-content" style={phoneView && "flex-direction: column;"}>
    <div class="carousel content anchored" style={"width: " + anchoredWidth + "px;"}>
      <ExerciseImageCarousel animate={!isWorkout} faIconString={icon} showNoGps={isWorkout} images={[...(images ?? []), map_url, street_view, chart_url, club?.logo]} {video_id} height={anchoredWidth * 200/354}/>
    </div>

    <div class="middle">
      {#if !halfView}
        <div class="left" style="max-width: 50%;">
          <div class="exercise-titles content">
            <div>
              <h2 class="title">
                <a href={titleLink} target={isWorkout ? "workout" : "activity"}>
                  {name != null && name.length > 0 ? name : "ERROR: No Name"}
                </a>
              </h2>
              {#if showOwner}
              <div class="ellipsis" style="margin-bottom: 10px;">
                <Avatar shape="circle" {...user} pad_right="true"/>
                <h4 class="title w400 ellipsis" style="display: inline; vertical-align: middle;">
                  {user != null  ? `${user.first_name} ${user.last_name}`: "ERROR: No username"}
                </h4>
              </div>
              {/if}
              {#if isActivity && !isTrainingPicker}
                <ActivityBreakthrough {medal} {signature} {br_signature_changes}/>
              {/if}
              
              {#if isSession}
                <SessionVideoData {isTemplate} {owner} {club} {members_to_show} {hidden_members} {video_provider} {video_name} {video_id}/>
              {/if}

              <p class="description" style={"-webkit-line-clamp: " + (isWorkout || isActivity && !medal ? "3" : "2")}>{description ?? ""}</p>
            </div>
            {#if showTags}
              <TagWrapper tags={updateTags(icon, exerciseTypeTag, power_source, repeat_type, sharing_type, tags)} />
            {/if}
          </div>
        </div>
      {/if}

      <div class="right" style={halfView ? "max-width: 100%" : "max-width: 50%; flex-grow: 1;"}>
        <div class="exercise-info content">
          {#if halfView && isSession}
            <SessionVideoData {isTemplate} {owner} {club} {members_to_show} {hidden_members} {video_provider} {video_name} {video_id}/>
          {/if}

          {#if (halfView) && isActivity && !isTrainingPicker}
            <div class="big-activity-stats">
              <span class="duration" style={phoneView && "flex-grow: 1;"}>
                <p>Duration</p>
                <h3>{format_duration(duration)}</h3>
              </span>
              <span class="duration" style={phoneView && "flex-grow: 1;"}>
                <p>Distance</p>
                <h3>{tidy(useFreedomUnits ? kmToMile(distance) : distance)} {useFreedomUnits ? "mi" : "km"}</h3>
              </span>
            </div>
            <ActivityBreakthrough {medal} {signature} {br_signature_changes}/>
          {/if}

          {#if (isActivity && (scheduled || halfView || isTrainingPicker)) || isSession || isWorkout}
            <span class="card-data">
              {#if !halfView && isSession && workout}
                <span class="ellipsis" style="display:block">
                  <h4>{workout.name}</h4>
                </span>
              {/if}
              {#if halfView && isSession && workout}
                {$_('sessions.card.workout_name')} <a href={workoutLink} target={isWorkout ? "workout" : "activity"}><b>{workout.name}</b></a>
                <br/>
              {/if}
              {#if distance}
                {$_('sessions.card.distance')}
                <b>{Math.round(useFreedomUnits ? kmToMile(distance) : distance)}
                  {useFreedomUnits ? "mi" : "km"}
                </b>
                <br/>
              {/if}
              {#if duration}
                {$_('sessions.card.duration')} <b>{format_duration(duration)}</b>
                <br/>
              {/if}
              {#if focus && (specificity ?? sp)}
                {$_('sessions.card.focus')} <b>{specificityToRating(specificity ?? sp)} {focus}</b>
                <br/>
              {/if}
              {#if formattedXSSstrings}
                {$_('sessions.card.xss')}{' '}
                <b style="font-weight: bold !important;">
                    {formattedXSSstrings.xss}
                    {'('}
                    <span class="nlow">{formattedXSSstrings.xlss}</span>
                    {' | '}
                    <span class="nhigh">{formattedXSSstrings.xhss}</span>
                    {' | '}
                    <span class="npeak">{formattedXSSstrings.xpss}</span>
                    {')'}
                </b>
                <br/>
              {/if}
              {#if difficulty}
                {$_('sessions.card.difficulty')} <DifficultyDiamonds {difficulty}/>
                <br/>
              {/if}
              {#if !isActivity && tgf && tgc}
                {$_('sessions.card.fatcarbs')} <b>{Math.round(tgf)} g / {Math.round(tgc)} g</b>
                <br/>
              {/if}
              {#if suitability}
                {$_('sessions.card.suitability')}{' '}
                {#if targetXSS && xssDetails}
                    <XssDeviationIcon category={xssDeviationToCategory(xssDetails, targetXSS).xss.suitability} />
                {/if}
                <b>{suitability}</b>
                <br/>
              {/if}
            </span>
          {:else if !halfView && isActivity && !scheduled}
            <span class="card-data">
              {#if avgPower && maxPower}
                Average/Max Power: <b>{Math.round(avgPower)} W / {Math.round(maxPower)} W</b>
                <br/>
              {/if}
              {#if avgHeartRate && maxHeartRate}
                Average/Max Heart Rate: <b>{Math.round(avgHeartRate)} BPM / {Math.round(maxHeartRate)} BPM</b>
                <br/>
              {/if}
              {#if avgSpeed && maxSpeed}
                Average/Max Speed: <b>{Math.round(useFreedomUnits ? kmToMile(avgSpeed) : avgSpeed)} {useFreedomUnits ? "MPH" : "KPH"} / {Math.round(useFreedomUnits ? kmToMile(maxSpeed) : maxSpeed)} {useFreedomUnits ? "MPH" : "KPH"}</b>
                <br/>
              {/if}
              {#if focus}
                {$_('sessions.card.focus')} <b>{specificityToRating(specificity ?? sp)} {focus}</b>
              <br/>
              {/if}
              {#if tgf && tgc}
                Fat/Carbohydrates: <b>{Math.round(tgf)} g / {Math.round(tgc)} g</b>
                <br/>
              {/if}
              {#if elevation}
                Elevation Gain: <b>{Math.round(useFreedomUnits ? meterToFoot(elevation) : elevation)} {useFreedomUnits ? "ft" : "m"}</b>
                <br/>
              {/if}
            </span>
          {/if}

          {#if isActivity && group_members?.length}
            <span class="card-data" style="display: flex; align-items: center; gap: 8px;">
              <i class="fa-solid fa-users" style="color: var(--xert-grey, #888);"></i>
              <GroupMemberAvatars members={group_members} />
            </span>
          {/if}

          {#if halfView && showTags}
            <TagWrapper tags={updateTags(icon, exerciseTypeTag, power_source, repeat_type, sharing_type, tags)} />
          {/if}
          {#if !halfView || phoneView && showExerciseCardButtons}
            <div class="buttons" style="margin-top: 5px;" >
              {#if isSession}
                <ExerciseCardButtons {selectable} path={isTemplate ? template_id : session_id} {session_id} {isTemplate} {isSession} {allowed_to_edit} {copySession} {copyThisSession}
                  {video_id} {zoom_url} {spotify_url} enable_share_button={!isTemplate && (not_yet_ended)} {allowed_to_delete} {isRecorded} {isPlanned}/>
              {:else if (isActivity && user?.username == Xert._username)}
                <ExerciseCardButtons {selectable}  isFlagged={flag} isStarred={favorite} {session_id} {isActivity} {deleteActivityCard} {reloadExercises} {path} {isRecorded} {isPlanned} canDelete={!state?.includes("no_delete")}  canFavorite={!state?.includes("no_favorite")} canFlag={!state?.includes("no_flag")}/>
              {:else if isWorkout}
                <ExerciseCardButtons {canSendToGarmin} {canSendToZwift} {canSendToWahoo} {selectable} allowDownload={allowed_to_schedule} isWorkout={true} isLiked={liked} isDisliked={disliked} {reloadExercises} {allowed_to_edit} {path} {name} {isRecorded} {isPlanned}/>
              {/if}
            </div>
          {/if}
        </div>
      </div>
    </div>

    <div class="divider" style={halfView && "display: none;"}/>

    <div class="duration-info anchored center content" style={"width: " + anchoredWidth + "px;" + (halfView && "display: none;")}>
      {#if (isActivity || isWorkout) && isNext && isTrainingPicker && start_date_obj}
        <h4 class="date" style="margin-bottom: 8px;">{format_daymonth(start_date_obj, $current_time)}{start_date_obj.getFullYear() != $current_time.getFullYear() ? ", " + start_date_obj.getFullYear() : ""}</h4>
        <h3 class="timestamp" style="white-space: nowrap;"><a target="activity" href={activity_url ?? `/activities/${isWorkout ? activityPath : path}${isWorkout ? `?forUser=${Xert._username}` : ""}`}>{timestamp}</a></h3>
      {:else}
        {#if isSession}
          {#if !isTemplate}
            <SessionButtons remaining_time={format_elapsed($current_time_highres, end_date_obj)} starting_in={format_timespan(start_date_obj, $current_time_highres)} {starting_at_date} {timestamp}
              {in_progress} {starting_soon} {in_past} {is_group_session} {joinSession} {joined} {session_id} {start_date} {end_date} {current_time} {current_time_highres}/>
          {:else}
            <SessionScheduleButton {isCalendarCard} {isActivityPicker} {isRecorded} {isPlanned} {onScheduleCallback} start_date={start_date} disabled={!allowed_to_schedule} {exerciseType} {activityPath} {playSessionNow} {clearExercise} {scheduleThisSession} {is_premium} {isReady}/>
          {/if}
        {:else if isActivity}
          <!-- Only one button can fit with the info text -->
          {#if (!(showPlayButton || showScheduleButton || showClearButton))}
            {#if !isTrainingPicker && start_date_obj}
              <h4 class="date" style="margin-bottom: 8px;">{format_daymonth(start_date_obj, $current_time)}{start_date_obj.getFullYear() != $current_time.getFullYear() ? ", " + start_date_obj.getFullYear() : ""}</h4>
              <h3 class="timestamp">{timestamp}</h3>
            {/if}
            <h4 class="w400 activity-data" style={!distance && "display: none;"}>Distance: <b>{tidy(useFreedomUnits ? kmToMile(distance) : distance)} {useFreedomUnits ? "mi" : "km"}</b></h4>
            {#if formattedXSSstrings}
                <h4 class="w400 activity-data">
                    {$_('sessions.card.xss')}{' '}
                    <b style="font-weight: bold !important;">
                        {formattedXSSstrings.xss}
                        {'('}
                        <span class="nlow">{formattedXSSstrings.xlss}</span>
                        {' | '}
                        <span class="nhigh">{formattedXSSstrings.xhss}</span>
                        {' | '}
                        <span class="npeak">{formattedXSSstrings.xpss}</span>
                        {')'}
                    </b>
                    <br/>
                </h4>
            {/if}
            <h4 class="w400 activity-data" style={!difficulty && "display: none;"}>Difficulty: <DifficultyDiamonds {difficulty}/></h4>
            <h4 class="w400 activity-data" style={!xep && "display: none;"}>XEP: <b>{Math.round(xep)} W</b></h4>
          {/if}
          <SessionScheduleButton {isCalendarCard} {isActivityPicker} {isRecorded} {isPlanned} {onScheduleCallback} start_date={start_date} {exerciseType} {activityPath} bind:showScheduleModal={showScheduleModal} {openPlayerOnPlay} {playSessionNow} {clearExercise} {phoneView} {halfView} scheduleThisSession={showScheduleModal} {path} {showScheduleButton} {showPlayButton} {showClearButton} {is_premium} {isReady}/>
        {:else if isWorkout}
          <SessionScheduleButton {isCalendarCard} {isActivityPicker} {isRecorded} {isPlanned} {onScheduleCallback} start_date={start_date} disabled={!allowed_to_schedule} {exerciseType} {activityPath} bind:showScheduleModal={showScheduleModal} {playSessionNow} {clearExercise} {phoneView} {halfView} scheduleThisSession={showScheduleModal} {openPlayerOnPlay} {path} {showScheduleButton} {showPlayButton} {showClearButton} {is_premium} {duration} {isReady}/>
        {/if}
      {/if}
    </div>
  </div>

  
  {#if halfView && showExerciseCardButtons}
    <div class="bottom" style={phoneView && "flex-direction: row; margin: 0 10px 5px 10px !important;"}>
      {#if !phoneView}
        <div class="buttons" style={"margin: 14px 0; display: flex;"}>
        {#if isSession}
          <ExerciseCardButtons {selectable} path={isTemplate ? template_id : session_id} {session_id} {isTemplate} {isSession} {allowed_to_edit} {copySession} {copyThisSession}
            {video_id} {zoom_url} {spotify_url} enable_share_button={!isTemplate && (not_yet_ended)} {allowed_to_delete} {isRecorded} {isPlanned}/>
        {:else if (isActivity && user?.username == Xert._username)}
          <ExerciseCardButtons {selectable} isFlagged={flag} isStarred={favorite} {session_id} {isActivity} {deleteActivityCard} {reloadExercises} {path} {isRecorded} {isPlanned} canDelete={!state?.includes("no_delete")}  canFavorite={!state?.includes("no_favorite")} canFlag={!state?.includes("no_flag")}/>
        {:else if isWorkout}
          <ExerciseCardButtons {selectable} {canSendToGarmin} {canSendToZwift} {canSendToWahoo} allowDownload={allowed_to_schedule} isWorkout={true} isLiked={liked} isDisliked={disliked} {reloadExercises} {allowed_to_edit} {path} {name} {isRecorded} {isPlanned}/>
        {/if}
        </div>
        <spacer style="flex-grow: 1;"/>
      {/if}
      {#if isWorkout && !isNext}
        <SessionScheduleButton {isCalendarCard} {isActivityPicker} {isRecorded} {isPlanned} {onScheduleCallback} start_date={start_date} disabled={!allowed_to_schedule} {exerciseType} {activityPath} bind:showScheduleModal={showScheduleModal} {playSessionNow} {clearExercise} flexDirection="row" {phoneView} {halfView} {openPlayerOnPlay} scheduleThisSession={showScheduleModal} {path} {showScheduleButton} {showPlayButton} {showClearButton} {is_premium} {duration} {isReady}/>
      {/if}
      {#if isSession && !isTemplate}
        <SessionButtons compactForm={true} {phoneView} remaining_time={format_elapsed($current_time_highres, end_date_obj)} starting_in={format_timespan(start_date_obj, $current_time_highres)} {starting_at_date} {timestamp}
          {in_progress} {starting_soon} {in_past} {is_group_session} {joinSession} {joined} {session_id} {start_date} {end_date} {current_time} {current_time_highres}/>
      {:else if isSession && isTemplate}
        <SessionScheduleButton {isCalendarCard} {isActivityPicker} {isRecorded} {isPlanned} {onScheduleCallback} start_date={start_date} disabled={!allowed_to_schedule} {exerciseType} {activityPath} flexDirection="row" {phoneView} {halfView} {playSessionNow} {clearExercise} {showScheduleButton} {showPlayButton} {showClearButton} {scheduleThisSession} {is_premium} {isReady}/>
      {/if}
      {#if ((isActivity || isWorkout) && isNext)}
        {#if start_date_obj}
        <span class="text">
          <h4 class="date" style={phoneView ? "text-align: left;" : "text-align: right;"}>{format_daymonth(start_date_obj, $current_time)}{start_date_obj.getFullYear() != $current_time.getFullYear() ? ", " + start_date_obj.getFullYear() : ""}</h4>
          <h3 class="timestamp" style="white-space: nowrap;"><a target="activity" href={activity_url ?? `/activities/${isWorkout ? activityPath : path}${isWorkout ? `?forUser=${Xert._username}` : ""}`}>{timestamp}</a></h3>
        </span>
        {/if}
      {:else if isActivity}
        {#if !isTrainingPicker && start_date_obj}
          <span class="text">
            <h4 class="date" style={phoneView ? "text-align: left;" : "text-align: right;"}>{format_daymonth(start_date_obj, $current_time)}{start_date_obj.getFullYear() != $current_time.getFullYear() ? ", " + start_date_obj.getFullYear() : ""}</h4>
            <h3 class="timestamp" style="white-space: nowrap;">{timestamp}</h3>
          </span>
        {/if}
        <SessionScheduleButton {isCalendarCard} {isActivityPicker} {isRecorded} {isPlanned} {onScheduleCallback} start_date={start_date} {exerciseType} {activityPath} bind:showScheduleModal={showScheduleModal} {openPlayerOnPlay} {playSessionNow} {clearExercise} flexDirection="row" {phoneView} {halfView} scheduleThisSession={showScheduleModal} {path} {showScheduleButton} {showPlayButton} {showClearButton} {is_premium} {isReady}/>
      {/if}
    </div>
  {/if}

</my-box>


<style lang="scss">
@import '../style/xert.scss';

my-box {

  position: relative;
  background: white;
  mix-blend-mode: var(--session-card-mix-blend-mode, none);

  &.selectable {
    border: 1px solid gainsboro;
  }

  &.selectable:hover {
    border: 1px solid rgb(170, 170, 170); // Slightly darker than gainsboro
  }

  &.selectable.selected, &.selectable.selected:hover{
    border: 3px solid var(--color-xert-teal) !important;
  }

  h3.title {
    margin: 15px 20px -5px 20px;
    line-height: 1.25;
    font-weight: 500;
  }

  .primary-content {
    display: flex;
  }
  .title > a {
    color: #34495e;
  }

  .title > a:hover, .title > a:focus {
    text-decoration: none;
    color: var(--color-xert-teal);
    cursor: pointer;
  }

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: clip;
}

.showBorder {
  border: 1px solid var(--color-xert-teal);
  border-radius: 5px;
}

.comments-button-anchor {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 2;
}
span.avatars {
  --avatar-height: 24px;

  display: flex;
  gap: 4px;
  width: 100%;
  max-width: var(--xert-button-width, unset);

  > div {
    margin: auto 0;
  }

  p {
    margin: 0;
    line-height: 1;
    color: var(--color-xert-gray-text);
  }
}

.bottom {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: right;
  margin: 0 20px 5px 20px;
  padding-top: 5px;
  border-top: 1px solid #E4E4E4;

  .buttons {
    display: flex;
    flex-direction: column;
    justify-content: right;
  }

  .text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 6px;

    > h4 {
      margin: 0;
      font-size: 14px !important;
    }

    > h3 {
      margin: 0;
    }
  }
}

.description {
  margin: 0;
  margin-bottom: 7px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.big-activity-stats {
  display: flex;
  gap: 40px;
  margin-bottom: 10px;

  p {
    display: inline;
    margin: 0;
  }

  h3 {
    margin: 0;
  }
}

.middle {
  min-width: 0;
  display: flex;
  flex-grow: 1;
  flex-direction: row;

  .right {
    display: flex;
    flex-direction: row;
  }

  .left {
    display: flex;
    flex-direction: row;
    flex-grow: 1;
  }
}

.content {
  position: relative;
}

.anchored {
  flex-shrink: 0;;
}

.carousel {
  margin: 24px 20px 0 20px;
  min-height: 100px;
  display: flex;
}
.exercise-titles {
  min-width: 200px;
  flex-grow: 1;
  margin: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h2 {
    margin-top: 0;
    margin-bottom: 7px;
    font-weight: 500;
    font-size: 20px;
  }
}

.exercise-info {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  min-width: 200px;
  margin: 20px;

  b {
    font-weight: 600 !important;
  }
}

.duration-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: clip;
  margin: 20px;

  h4 {
    margin: 0;
  }

  --xert-button-width: 210px;

  .activity-data {
    font-size: 15px !important;
    margin-top: 5px;
  }
}

.divider {
  border-right: 1px solid #E4E4E4;
  margin: 20px 0;
}

.card-data {
  font-family: "Open Sans", sans-serif !important;
  font-size: 14px;
  margin-bottom: 10px;

  h4 {
    margin-top: 0;
    font-weight: 700;
  }
}

.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.date {
  font-size: 18px !important;
  line-height: 21px !important;
}

.timestamp {
  font-weight: 500 !important;
  font-size: 22px !important;
  margin-top: 0;
}

.center {
  text-align: center;
  align-items: center;
}

.npeak {    
    color: #F00;
}
.nlow {
    color: #0B5DBC;
}
.nhigh {
    color: #F5A623;
}

</style>
